import React from 'react'
import PropTypes from 'prop-types'
import {ListItemSecondaryText as RmwcListItemSecondaryText} from '@rmwc/list'
import '@rmwc/list/styles'

const DrawerListItemSecondaryText = ({children, ...otherProps}) => <RmwcListItemSecondaryText {...otherProps}>{children}</RmwcListItemSecondaryText>

DrawerListItemSecondaryText.propTypes = {
  children: PropTypes.any
}

export {DrawerListItemSecondaryText}
